import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { fetchBookingList } from "../services/adminApiService/venueManagerApi/venueManagerApi";
import { PaginationControl } from "react-bootstrap-pagination-control";
import Form from "react-bootstrap/Form";
import PageTitle from "../jsx/layouts/PageTitle";
import useSearchValue from "../hooks/useSearchValue";
import UserToggle from "./BookForOthers.jsx/Index";

function BookingList() {
  const loginDetails = JSON.parse(
    localStorage.getItem("login_Details") || "{}",
  );
  const [data, setData] = useState([]);
  const [venueFilter, setVenueFilter] = useState(
    loginDetails?.user?.venue_id || "",
  );
  const [sportFilter, setSportFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [sportOptions, setSportOptions] = useState([]);
  const [totalItems, setTotalItems] = useState("");
  const [sportDropdown, setSportDropdown] = useState([])
  // const [searchValue, setSearchValue] = useState("");
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const { searchValue, setSearchValue, debouncedSearchValue } =
    useSearchValue(1000);
  const limit = 10;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`; // "11 Oct, 2025"
  };
  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  useEffect(() => {
    const getBookings = async () => {
      const bookings = await fetchBookingList({
        page,
        limit,
        venue: venueFilter,
        sport: sportFilter,
        status: statusFilter,
        search: debouncedSearchValue,
      });


      setData([...(bookings.data || [])]);
      setSportDropdown(bookings?.sport || []);
      setTotalItems(bookings?.totalItems);

      const uniqueSportsMap = new Map();
      bookings?.data?.forEach((booking) => {
        const sportName = booking?.sport?.sport_name;
        const sportId = booking?.sport?.id;

        if (sportName && sportId && !uniqueSportsMap.has(sportId.toString())) {
          uniqueSportsMap.set(sportId.toString(), sportName);
        }
      });

      setSportOptions(
        Array.from(uniqueSportsMap).map(([id, name]) => ({
          value: id,
          label: name,
        })),
      );
    };

    getBookings();
  }, [page, venueFilter, sportFilter, statusFilter, debouncedSearchValue]);

  useEffect(() => {
    setPage(1);
  }, [venueFilter, sportFilter, statusFilter, debouncedSearchValue]);

  const handleBookingDetails = (id) => {
    localStorage.setItem("venueManagerBookingId", id);
    window.location.href = `/booking-details/${id}`;
  };

  return (
    <>
      <h1 className="mb-3 fs-2 ">
        <PageTitle
          motherMenu={"Customer Bookings"}
          activeMenu={"Booking List"}
        />
      </h1>
      <div className="d-flex justify-content-between align-items-end bg-default p-3 flex-wrap gap-3">
        {/* Search Input (Left Side - Wider) */}
        <Form.Group
          className="mb-0 flex-grow-1"
          controlId="exampleForm.ControlInput1"
        >
          <Form.Label>Seach by Booking ID</Form.Label>
          <Form.Control
            type="text"
            placeholder="Seach by Booking ID..."
            className="p-2"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </Form.Group>

        {/* Filters Group (Right Side - Fixed Size) */}
        <div className="d-flex gap-4 flex-grow-0">
          <Form.Group className="mb-0" style={{ minWidth: "180px" }}>
            <Form.Label>Sport</Form.Label>
            <Form.Select
              value={sportFilter}
              onChange={(e) => setSportFilter(e.target.value)}
              className="p-2"
            >
              <option value="">All Sports</option>
              {sportDropdown?.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.sport_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-0" style={{ minWidth: "180px" }}>
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={statusFilter}
              onChange={handleStatusChange}
              className="p-2"
            >
              <option value="">Select status</option>
              {/* <option value="Inprocess">Inprocess</option> */}
              <option value="Verified">Verified</option>
              <option value="Canceled">Cancelled</option>
              <option value="Rejected">Rejected</option>
              {/* <option value="Pending">Pending</option> */}
              <option value="Failed">Failed</option>
              <option value="Completed">Completed</option>
            </Form.Select>
          </Form.Group>
        </div>
      </div>

      <div className="table-wrapper">
        <div className="table-container">
          <table className="booking-table">
            <thead>
              <tr className="table-header-row">
                <th>Booking ID</th>
                <th>Slot / Date</th>
                <th>Venue</th>
                <th>Sport</th>
                <th>Requested By</th>
                <th>Customer</th>
                <th>Status</th>
                {/* <th>Approve/Reject</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((booking) => (
                <tr key={booking?.id} className="table-body-row">
                  <td>{booking?.booking_id}</td>
                  <td>
                    <div className="booking-slot-time">
                      {booking?.slot_from_time} - {booking?.slot_to_time}
                    </div>
                    <div
                      className="booking-slot-date"
                      style={{ color: "rgba(156, 163, 175, 1)" }}
                    >
                      {formatDate(booking.slot_from_date)}
                    </div>
                  </td>
                  <td>{booking?.venue?.venue_name}</td>
                  <td>{booking?.sport?.sport_name}</td>
                  <td>{booking?.booked_by ? "Venue Manager" : "User"}</td>
                  <td className="td-middle">
                    {booking?.user?.name || ""}
                    <div
                      className="booking-slot-date"
                      style={{ color: "rgba(156, 163, 175, 1)" }}
                    >
                      {booking?.email_id}
                    </div>
                  </td>
                  <td className="td-middle">
                    <span
                      className={`status-badge ${
                        booking?.booking_status === "Pending"
                          ? "status-pending"
                          : booking?.booking_status === "Completed" ||
                              booking?.booking_status === "Verified"
                            ? "status-completed"
                            : "status-canceled"
                      }`}
                    >
                      {booking?.booking_status}
                    </span>
                  </td>

                  {/* <td>
                {booking?.booking_status === "Pending" ? (
                  <div className="action-buttons">
                    <div onClick={() => handleCheck(booking?.id, "Completed")}>
                      <img src="/assets/check.png" alt="Check" width={20} height={20} />
                    </div>
                    <div onClick={() => handleRejectClick(booking?.id, "Canceled")}>
                      <img src="/assets/cancel.png" alt="Cancel" width={20} height={20} />
                    </div>
                  </div>
                ) : booking?.booking_status === "Completed" ? (
                  <div className="action-single">
                    <img src="/assets/check.png" alt="Check" width={20} height={20} />
                  </div>
                ) : booking?.booking_status === "Canceled" ? (
                  <div className="action-single">
                    <img src="/assets/cancel.png" alt="Cancel" width={20} height={20} />
                  </div>
                ) : null}
              </td> */}
                  <td>
                    <div
                      onClick={() => handleBookingDetails(booking.id)}
                      className="flex items-center cursor-pointer"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        backgroundColor: "#eaecf0",
                        padding: "5px",
                        borderRadius: "10px",
                      }}
                    >
                      <FaEye
                        style={{
                          width: "16px",
                          height: "16px",
                          paddingLeft: "3px",
                        }}
                      />
                      <span style={{ width: "10px" }}>View</span>
                    </div>

                    {/* <Button variant="ghost" size="icon">
                      <div>
                       
                 
                      </div>
                    </Button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {data?.length > 0 ? (
        <PaginationControl
          page={page}
          between={4}
          total={totalItems || 250}
          limit={limit}
          changePage={(page) => {
            setPage(page);
          }}
          ellipsis={1}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center fs-4 p-3">
          No data available
        </div>
      )}
    </>
  );
}

export default BookingList;
